import { render, staticRenderFns } from "./ChipMultiSelect.vue?vue&type=template&id=3b4502ef"
import script from "./ChipMultiSelect.vue?vue&type=script&lang=js"
export * from "./ChipMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports